import { Button } from '@/components/ui/button';
export default function MfAuthDesktop({
  MFAInfo,
  mfaAuthData,
  openModalIndex,
  setOpenModalIndex
}) {
  const hasSyncedItem = mfaAuthData.some(item => item.status === 'Synced');
  const toggleModal = (index: number) => {
    setOpenModalIndex(index === openModalIndex ? null : index);
  };
  const renderCustomDialog = (infoItem: any, index: number, buttonText: string) => {
    const isDisabled = infoItem.status !== 'Synced' && hasSyncedItem;
    return <>
        <Button onClick={() => !isDisabled && toggleModal(index)} className={`rounded-full bg-genius-blue md:hover:bg-genius-blue text-genius-cream ${buttonText === 'Disconnect' ? 'w-[100px]' : 'w-[90px]'} h-8`} disabled={isDisabled} data-sentry-element="Button" data-sentry-source-file="MfAuthDesktop.tsx">
          {buttonText}
        </Button>
      </>;
  };
  return <>
      {mfaAuthData.map((infoItem, index) => <div className={`flex py-4 pr-0 items-center w-full`} key={index}>
          <div className={`flex w-full ${infoItem.status !== 'Synced' && hasSyncedItem ? 'opacity-50' : ''}`}>
            <div className='flex items-center gap-x-2 mr-4'>{infoItem.icon}</div>
            <div className='flex items-center gap-x-2 w-5/6'>
              <div className='flex flex-col gap-y-[2px]'>
                <p className='text-base/4 text-genius-cream'>{infoItem.title}</p>
                <p className='text-genius-cream/50 text-xs/3'>
                  {infoItem.status === 'Synced' ? <span className='text-green-400'>
                      Synced: <span className='text-genius-cream/50'>{MFAInfo.providerValue}</span>
                    </span> : 'Add an additional login method'}
                </p>
              </div>
            </div>
            <div className='control flex flex-col ta-r justify-end'>
              {infoItem.kind === '' && renderCustomDialog(infoItem, index, 'Disconnect')}
              {['connect', 'wait']?.includes(infoItem.kind) && renderCustomDialog(infoItem, index, 'Connect')}
            </div>
          </div>
        </div>)}
    </>;
}